const listViewToggle = () => {
  const toggle = document.querySelector('.map-list-view-toggle')
  const list = document.querySelector('.map-list-view')

  if (toggle !== null && list !== null) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault()
      list.classList.toggle('map-list-view--active')
    })
  }
}

function init() {
  listViewToggle()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/listViewToggle.js